import { render, staticRenderFns } from "./AuthLoginLayout.vue?vue&type=template&id=64100840&"
import script from "./AuthLoginLayout.vue?vue&type=script&lang=js&"
export * from "./AuthLoginLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64100840')) {
      api.createRecord('64100840', component.options)
    } else {
      api.reload('64100840', component.options)
    }
    module.hot.accept("./AuthLoginLayout.vue?vue&type=template&id=64100840&", function () {
      api.rerender('64100840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Layout/AuthLoginLayout.vue"
export default component.exports